
export default {
    name: "popup_on_demand",
    props: ["room", "agenda"],
    data(){
        return {
            isLoading: true,
            selectedLang: "en",
            playingVideoItem: null,

            langText: {
                en: {
                    check_later: "Do check back later!",
                    open_video: "OPEN",
                    back: "Back",
                    download: "Download Resource",
                    disclaimer: "On-demand videos of the live sessions will be added by 12 p.m. (SGT) the next day."
                    // disclaimer: "On-demand videos of the live sessions will be added by 12 p.m. (SGT) the next day. <br>For employees who have access to Campus on Cloud, please click <a href='https://forms.office.com/Pages/ResponsePage.aspx?id=1k_SlcVagUCFNNIiMHZEQRn5OWSD8aVKk24M2XDUXaRUQURON1lZVUZVQTNGS0VSU01QRVZKOUlGMi4u' target='_blank' class='text-blue-500 underline'>here</a> to register for workshops – using your work device – to be accorded with training hour(s). If you do not have a work device with you now, you can come back later to the on-demand section for the registration link.<br>Employees who do not have access to Campus on Cloud will be accorded with training hour(s) based on your submission during your first login."
                },
                cn: {
                    check_later: "请稍后再回来查看！",
                    open_video: "打开",
                    back: "返回",
                    download: "下载资源",
                    disclaimer: "点播视频将于第二天中午 12 p.m. (SGT) 添加。"
                    // disclaimer: "点播视频将于第二天中午 12 p.m. (SGT) 添加。<br>有Campus on Cloud 使用权的员工可用公司的设备点击<a href='https://forms.office.com/Pages/ResponsePage.aspx?id=1k_SlcVagUCFNNIiMHZEQRn5OWSD8aVKk24M2XDUXaRUQURON1lZVUZVQTNGS0VSU01QRVZKOUlGMi4u' target='_blank' class='text-blue-500 underline'>此网址</a>来报名工作坊。您的训练时数将被记录。如您现在没有公司设备，您稍后可以依照视频上的网址报名。<br>没有Campus on Cloud 使用权的员工将会依据您初登入时提交的资料来统计训练的时数。"
                }
            },

            items: []
        }
    },
    computed: {

    },
    mounted(){
        this.$axios.$get(`/past_video/${ this.room }`, this.tokenHeader).then((res) => {
            console.log("onDemandCallback", res);
            this.items = res.items.map(item => ({
                ...item,
                ...this.findSessionByStamp(item.stamp)
            }));
            this.isLoading = false;
        }).catch((err) => {
            console.error("onDemandError", err);
            return this.onHandleApiError(err);
        });
    },
    methods: {
        findSessionByStamp(stamp){
            const result = {
                title_en: null,
                title_cn: null
            };

            for(const key in this.agenda){
                if(!/^week\d+$/.test(key)) continue;

                const days = this.agenda[key];
                for(const day of days){
                    for(const enItem of day.enitems || []){
                        if(enItem.stamp === stamp){
                            result.title_en = enItem.title;
                        }
                    }

                    for(const cnItem of day.cnitems || []){
                        if(cnItem.stamp === stamp){
                            result.title_cn = cnItem.title;
                        }
                    }

                    if(result.title_en && result.title_cn){
                        return result;
                    }
                }
            }

            return (result.title_en || result.title_cn)? result : null;
        },
        onClickPlayVideo(item){
            this.playingVideoItem = item;
            this.$emit("update:isSystemMuted", true);
            this.onHandleTriggerAnalytics(`open@${ item.stamp } (${ this.selectedLang })@on_demand@${ this.room }`); 

            if(item.stamp && item.room){
                this.$store.dispatch("stamp/onSubmitStamp", { title: item.stamp, room: this.roomItems[item.room] });
            }
        },
        onClickDownloadBtn(item){
            this.onHandleTriggerAnalytics(`download@resource@${ item.stamp } (${ this.selectedLang })@${ this.room }`); 
        },
        onClickBackBtn(){
            this.playingVideoItem = null;
            this.$emit("update:isSystemMuted", false);
        },
        onClickCloseBtn(){
            this.$emit("update:isSystemMuted", false);
            this.$emit("update:currentPopupItem", null);

            this.onHandleTriggerAnalytics(`close@on_demand@${ this.room }`); 
        },
    },
    watch: {
        "selectedLang"(){
            this.onHandleTriggerAnalytics(`change_language@${ this.selectedLang }@on_demand@${ this.room }`); 
        }
    }
}
